const { userConstants } = require("../constants/userConstant");


let loginnrdUser =(localStorage.getItem('currentUser')!=undefined)? JSON.parse(localStorage.getItem('currentUser')):null;
//let obj=JSON.parse(localStorage.getItem('user'));
const initialState = {
  isAuthenticate: loginnrdUser == null ? false : true,
  currentMobile:loginnrdUser == null?'':loginnrdUser.mobile,
  currentServiceTypeId: 0,
  // currentCustomerInfo: {
  //   "provinceId": (loginnrdUser == null ? 0 : loginnrdUser.provinceId),
  //   "cityId": (loginnrdUser == null ? 0 : loginnrdUser.cityId),
  //   "regionId": (loginnrdUser == null ? 0 : loginnrdUser.regionId),
  //   "parishId": (loginnrdUser == null ? 0 : loginnrdUser.parishId),
  //   "userId": (loginnrdUser == null ? 0 : loginnrdUser.userId),
  //   "mobile": (loginnrdUser == null ? "" : loginnrdUser.userName),
  //   "firstName": (loginnrdUser == null ? "" : loginnrdUser.firstName),
  //   "lastName": (loginnrdUser == null ? "" : loginnrdUser.lastName),
  //   "address": (loginnrdUser == null ? "" : loginnrdUser.lastAddress),
  // },
  currentUser:loginnrdUser==null?{
    "provinceId": (loginnrdUser == null ? '' : loginnrdUser.provinceId),
    "cityId": (loginnrdUser == null ? '' : loginnrdUser.cityId),
    "regionId": (loginnrdUser == null ? '' : loginnrdUser.regionId),
    "parishId": (loginnrdUser == null ? '' : loginnrdUser.parishId),
    "userId": (loginnrdUser == null ? '': loginnrdUser.userId),
    "mobile": (loginnrdUser == null ? "" : loginnrdUser.userName),
    "firstName": (loginnrdUser == null ? "" : loginnrdUser.firstName),
    "lastName": (loginnrdUser == null ? "" : loginnrdUser.lastName),
    "address": (loginnrdUser == null ? "" : loginnrdUser.lastAddress),
  }:loginnrdUser
}
function userReducer(state = initialState, action) {  
  switch (action.type) {
    case userConstants.SET_CURRENT_CUSTOMER: return Object.assign({}, state, {
      currentCustomerInfo: action.customer,
      isAuthenticate: true
    })
    case userConstants.REQUEST_CODE: return Object.assign({}, state, {
      currentMobile: action.currentMobile,
    })
    case userConstants.SET_CURRENT_USER: return Object.assign({}, state, {
      currentUser: action.currentUser,      
      isAuthenticate: true
    })    
    case userConstants.SET_SERVICETYPE: return Object.assign({}, state, {
      currentServiceTypeId: action.currentServiceTypeId,
    })
    default: return state;
  }
}
export { userReducer };